import basketball from '../../assets/multiplayer-backgrounds/basketball.svg';
import bingoSnowBg from '../../assets/multiplayer-backgrounds/bingo_snow.svg';
import breakIce from '../../assets/multiplayer-backgrounds/breakIce.svg';
import bullseye from '../../assets/multiplayer-backgrounds/bullseye.svg';
import carCross from '../../assets/multiplayer-backgrounds/carCross.svg';
import colorArc from '../../assets/multiplayer-backgrounds/colorArc.svg';
import fallingFruit from '../../assets/multiplayer-backgrounds/fallingFruit.svg';
import footballFrenzyBg from '../../assets/multiplayer-backgrounds/footballFrenzy_bg.svg';
import jackpotBg from '../../assets/multiplayer-backgrounds/jackpot_bg.svg';
import ladybugs from '../../assets/multiplayer-backgrounds/ladybugs.svg';
import memory from '../../assets/multiplayer-backgrounds/memory.svg';
import miniGolf from '../../assets/multiplayer-backgrounds/miniGolf.svg';
import money from '../../assets/multiplayer-backgrounds/money.svg';
import orderUp from '../../assets/multiplayer-backgrounds/orderUp.svg';
import pillSkill from '../../assets/multiplayer-backgrounds/pillSkill.svg';
import plinkoBg from '../../assets/multiplayer-backgrounds/plinko_bg.svg';
import safelyHome from '../../assets/multiplayer-backgrounds/safelyHome.svg';
import skiSaga from '../../assets/multiplayer-backgrounds/skiSaga.svg';
import spiders from '../../assets/multiplayer-backgrounds/spiders.svg';
import takeFlight from '../../assets/multiplayer-backgrounds/takeFlight.svg';
import videoPractice from '../../assets/multiplayer-backgrounds/videoPractice.svg';
import cruiseBingo from '../../../static/assets/game_icons/cruise_bingo.png';

export type CardTheme = {
  background: string;
  buttonColor: string;
  image?: string;
};

type CardThemes = {
  [key: string]: CardTheme;
};

export const cardThemes: CardThemes = {
  'Hoop Stars': {
    background: '#232740',
    buttonColor: '#4A4F92',
    image: basketball,
  },
  'Break The Ice': {
    background: 'linear-gradient(254.17deg, #7196BF -0.96%, #607D9C 57.77%, #324C6C 98.95%)',
    buttonColor: '#354F6F',
    image: breakIce,
  },
  'Cruise Bingo': {
    background: 'linear-gradient(254.17deg, #90AFFF -0.96%, #E72B64 98.95%)',
    buttonColor: '#4A4F92',
    image: cruiseBingo,
  },
  'Bulls Eye': {
    background: 'linear-gradient(254.17deg, #90AFFF -0.96%, #E72B64 98.95%)',
    buttonColor: '#E3326C',
    image: bullseye,
  },
  'Car Cross': {
    background: 'linear-gradient(254.17deg, #FFF96F -0.96%, #5CBCBE 51.63%, #049C9E 98.95%)',
    buttonColor: '#0A9EA1',
    image: carCross,
  },
  'Color Arc': {
    background: 'linear-gradient(254.56deg, #CCEBF3 -3.06%, #75D3EC 31.83%, #0593B8 98.93%)',
    buttonColor: '#0C97BB',
    image: colorArc,
  },
  'Falling Fruit': {
    background: 'linear-gradient(254.56deg, #FF6550 -3.06%, #C2045C 100%)',
    buttonColor: '#FF6605',
    image: fallingFruit,
  },
  'Football Frenzy': {
    background: 'linear-gradient(254.56deg, #ee4dae -3.06%, #fb5c03 98.93%)',
    image: footballFrenzyBg,
    buttonColor: '#093f9f',
  },
  Jackpot: {
    background: 'linear-gradient(254.17deg, #ff3898 -0.95%, #ff0301 100%)',
    image: jackpotBg,
    buttonColor: '#ff0d1B',
  },
  Ladybugs: {
    background: 'linear-gradient(254.56deg, #5C8B00 -3.06%, #C2AF00 100%)',
    buttonColor: '#769501',
    image: ladybugs,
  },
  'Let it Snow Bingo': {
    background: 'linear-gradient(254.56deg, #FF6550 -3.06%, #C2045C 100%)',
    buttonColor: '#C70C5C',
    image: bingoSnowBg,
  },
  'Memory Game': {
    background: 'linear-gradient(254.17deg, #CB6BC7 -0.96%, #802566 100%)',
    buttonColor: '#852A6D',
    image: memory,
  },
  'Mini Golf Masters': {
    background: 'linear-gradient(254.17deg, #FFFFFF -0.96%, #ADE347 41.63%, #448140 98.95%)',
    buttonColor: '#4C8841',
    image: miniGolf,
  },
  'Money Mania': {
    background: 'linear-gradient(254.17deg, #FCD646 -0.96%, #49230A 100%)',
    buttonColor: '#57310F',
    image: money,
  },
  'Order Up': {
    background: 'linear-gradient(254.22deg, #E0F3FF 1.33%, #5C8FD6 78.93%)',
    buttonColor: '#5D90D7',
    image: orderUp,
  },
  'Pill Skill': {
    background: 'linear-gradient(254.17deg, #08C4FE -0.96%, #2B63F3 98.95%)',
    buttonColor: '#2968F4',
    image: pillSkill,
  },
  Plinko: {
    background: 'linear-gradient(254.56deg, #6f9acd -3.06%, #003459 98.93%)',
    image: plinkoBg,
    buttonColor: '#073a60',
  },
  'Safely Home': {
    background: 'linear-gradient(254.56deg, #1DC2DA -3.06%, #360C6D 98.93%)',
    buttonColor: '#351874',
    image: safelyHome,
  },

  'Ski Saga': {
    background: 'linear-gradient(254.56deg, #007A56 -3.06%, #8850FF 98.93%)',
    buttonColor: '#6150F7',
    image: skiSaga,
  },
  'Swinging Spiders': {
    background: 'linear-gradient(254.56deg, #F1B8FF -3.06%, #5D03A4 98.93%)',
    buttonColor: '#6150F7',
    image: spiders,
  },
  'Take Flight': {
    background: 'linear-gradient(254.56deg, #996983 -3.06%, #077882 100%)',
    buttonColor: '#107883',
    image: takeFlight,
  },
  'Video Practice': {
    background: 'linear-gradient(254.56deg, #9E7CF4 -3.06%, #454C8D 100%)',
    buttonColor: '#4A4F92',
    image: videoPractice,
  },

  'Sequence It': {
    background: 'linear-gradient(254.56deg, #0D005C -3.06%, #FF5C00 98.93%)',
    buttonColor: '#FF6605',
    // NO IMAGE
  },
  'Coronavirus Prevention': {
    // MISSING
    background: 'linear-gradient(254.56deg, #FF6550 -3.06%, #C2045C 100%)',
    buttonColor: '#c70c5c',
  },
  "Cupid's Arrow": {
    // MISSING
    background: 'linear-gradient(254.56deg, #FF6550 -3.06%, #C2045C 100%)',
    buttonColor: '#c70c5c',
  },
  'Election Hockey': {
    // MISSING
    background: 'linear-gradient(254.56deg, #FF6550 -3.06%, #C2045C 100%)',
    buttonColor: '#c70c5c',
  },
  'Elf on the Slope': {
    // MISSING
    background: 'linear-gradient(254.56deg, #FF6550 -3.06%, #C2045C 100%)',
    buttonColor: '#c70c5c',
  },
  'Fall Feast': {
    // MISSING
    background: 'linear-gradient(254.56deg, #FFEC41 10.41%, #FF5C00 98.93%)',
    buttonColor: '#c70c5c',
  },
  'Freedom Flight': {
    // MISSING
    background: 'linear-gradient(254.56deg, #FF6550 -3.06%, #C2045C 100%)',
    buttonColor: '#c70c5c',
  },
  'Fright Flight': {
    // MISSING
    background: 'linear-gradient(254.56deg, #FF6550 -3.06%, #C2045C 100%)',
    buttonColor: '#c70c5c',
  },
  'Jack-Pot of Gold': {
    // MISSING
    background: 'linear-gradient(254.56deg, #FF6550 -3.06%, #C2045C 100%)',
    buttonColor: '#c70c5c',
  },
  'Jolly Holly Slots': {
    // MISSING
    background: 'linear-gradient(254.56deg, #FF6550 -3.06%, #C2045C 100%)',
    buttonColor: '#c70c5c',
  },
  "Leprechaun's Loot": {
    // MISSING
    background: 'linear-gradient(254.56deg, #FF6550 -3.06%, #C2045C 100%)',
    buttonColor: '#c70c5c',
  },
  'Love Connection': {
    // MISSING
    background: 'linear-gradient(254.56deg, #FF6550 -3.06%, #C2045C 100%)',
    buttonColor: '#c70c5c',
  },
  'Rock Climbing Ruins': {
    // MISSING
    background: 'linear-gradient(254.56deg, #FF6550 -3.06%, #C2045C 100%)',
    buttonColor: '#c70c5c',
  },
  "Santa's Sleigh": {
    // MISSING
    background: 'linear-gradient(254.56deg, #FF6550 -3.06%, #C2045C 100%)',
    buttonColor: '#c70c5c',
  },
  'Scary Slots': {
    // MISSING
    background: 'linear-gradient(254.56deg, #FF6550 -3.06%, #C2045C 100%)',
    buttonColor: '#c70c5c',
  },
  'Slots of Love': {
    // MISSING
    background: 'linear-gradient(254.56deg, #FF6550 -3.06%, #C2045C 100%)',
    buttonColor: '#c70c5c',
  },
  'Slots of Summer': {
    // MISSING
    background: 'linear-gradient(254.56deg, #FF6550 -3.06%, #C2045C 100%)',
    buttonColor: '#c70c5c',
  },
  Spaceship: {
    // MISSING
    background: 'linear-gradient(254.56deg, #FF6550 -3.06%, #C2045C 100%)',
    buttonColor: '#c70c5c',
  },
  "St Patty's Plinko": {
    // MISSING
    background: 'linear-gradient(254.56deg, #FF6550 -3.06%, #C2045C 100%)',
    buttonColor: '#c70c5c',
  },
  Supermarket: {
    // MISSING
    background: 'linear-gradient(254.56deg, #FF6550 -3.06%, #C2045C 100%)',
    buttonColor: '#c70c5c',
  },
  'Turkey Hunt': {
    // MISSING
    background: 'linear-gradient(254.56deg, #FF6550 -3.06%, #C2045C 100%)',
    buttonColor: '#c70c5c',
  },
  default: {
    background: 'linear-gradient(254.56deg, #FF6550 -3.06%, #C2045C 100%)',
    buttonColor: '#c70c5c',
  },
};
